import { render, staticRenderFns } from "./BulletinPage.vue?vue&type=template&id=674cb56c"
import script from "./BulletinPage.vue?vue&type=script&lang=js"
export * from "./BulletinPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports